// TODO: Удалить из кора, оставить этот

export function getTextWidth(
  element: HTMLElement | string,
  fontSize?: number,
  fontWeight?: number
): number {
  const position: string = `display: inline;
   top: 0;
   left: -9999px;
   position: absolute;
   white-space: nowrap;
   font-size: ${fontSize || 16}px;
   font-weight: ${fontWeight || 300};
   backface-visibility: hidden;`
  const measurer = document.createElement('div')

  measurer.setAttribute('style', position)

  if (typeof element === 'string') {
    measurer.innerHTML = element
  } else {
    measurer.appendChild(element)
  }
  document.body.appendChild(measurer)

  const width = measurer.getBoundingClientRect().width

  document.body.removeChild(measurer)
  return width
}
